module.exports = __webpack_public_path__ + "img/visual_platform_2.676bcfc2.png";